// Automatically generated in 'npm version' by scripts/genversion.js

'use strict'
const version = '6.2.5';
export default version;
